const tokenize = (text: string): string[] => {
  return text
    .replace(/…/g, ' ... ')
    .replace(/([.,!?])/g, ' $1 ')
    .split(/\s+/)
    .filter(Boolean);
}

export function getWordsWithWeights(tokens: string[]) {
  return tokens.map(token => {
    let weight = Math.max(token.length, 1);

    if (token === '...') weight *= 1.75;
    else if (/[.,!?]/.test(token)) weight *= 3;
    else if (/^(ahh|uh|umm)$/i.test(token)) weight *= 1.75;
    else weight *= 1.2;

    return { word: token, weight };
  });
}

export function generateWordTimestamps(
  text: string,
  totalDuration: number
) {
  const tokens = tokenize(text);
  const weighted = getWordsWithWeights(tokens);

  const totalWeight = weighted.reduce(
    (sum, w) => sum + w.weight,
    0
  );

  let elapsed = 0;

  return weighted.map(({ word, weight }) => {
    const duration = (weight / totalWeight) * totalDuration;
    const start = elapsed;
    const end = elapsed + duration;
    elapsed = end;

    return {
      word,
      start: +start.toFixed(3),
      end: +end.toFixed(3)
    };
  });
}

export const groupWordsToLines = (
  wordTimeline: { word: string; start: number; end: number }[],
  maxChars = 75
) => {
  const lines: any[] = [];
  let currentWords: any[] = [];
  let charCount = 0;

  for (const w of wordTimeline) {
    const len = w.word.length + 1;

    if (charCount + len > maxChars) {
      lines.push({
        word: currentWords.map(w => w.word).join(' ')
        .replaceAll('. . .', '… ')
        .replaceAll(' ,', ',')
        .replaceAll(' .', '.')
        .replaceAll(' !', '!')
        .replaceAll(' ?', '?'),
        start: currentWords[0].start,
        end: currentWords[currentWords.length - 1].end,
        words: currentWords
      });
      currentWords = [];
      charCount = 0;
    }

    currentWords.push(w);
    charCount += len;
  }

  if (currentWords.length) {
    lines.push({
      word: currentWords.map(w => w.word).join(' ')
      .replaceAll('. . .', '…')
      .replaceAll(' ,', ',')
      .replaceAll(' .', '.')
      .replaceAll(' !', '!')
      .replaceAll(' ?', '?'),
      start: currentWords[0].start,
      end: currentWords[currentWords.length - 1].end,
      words: currentWords
    });
  }
  return lines;
}